import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmVolume, IconLlmVolumeX } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm';
import style from './page-synthesis.module.scss';

export const PageSynthesis: React.FC = () => {
  const label = useLabel();
  const speakEnabled = useLlm(state => state.speakEnabled);
  const { toggleSpeak, hasSpeechSynthesisSupport } = useLlm(state => state.actions);
  const hasSpeechSynthesis = hasSpeechSynthesisSupport();
  return hasSpeechSynthesis && (
    <button type="button" className={getClassNames(style.synthesis)}
      aria-label={speakEnabled ? label('llm.disableSpeak') : label('llm.enableSpeak')}
      aria-pressed={speakEnabled}
      onClick={toggleSpeak}
    >
      {speakEnabled ? <IconLlmVolume /> : <IconLlmVolumeX />}
    </button>
  );
};
